import i from "./index275.js";
import { resolveComponent as t, createBlock as d, openBlock as o, resolveDynamicComponent as b, mergeProps as m, withCtx as p, createElementBlock as a, createCommentVNode as l, createVNode as f, normalizeClass as r, renderSlot as s } from "vue";
import g from "./index231.js";
const u = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center",
  "data-test-id": "spinner"
};
function h(e, y, c, S, w, D) {
  const n = t("cs-button-loading-spinner");
  return o(), d(b(e.getTag), m({
    class: ["flex items-center transition-colors duration-200 border border-solid ease-ms rounded-normal", {
      "px-16": e.hasDefaultSlot() && !e.isSmall || e.hasDefaultSlot() && e.isSmall && !e.hasIconSlot(),
      "px-8": e.hasDefaultSlot() && e.isSmall && e.hasIconSlot(),
      "justify-center": !e.hasDefaultSlot() || e.isCentered,
      "text-center": e.isCentered,
      "active:translate-y-2": !e.hasClickArea && !e.isDisabled && !e.isLoading,
      "after:inset-0 after:absolute": e.hasClickArea,
      " hover:bg-color-brand-yellow-200 focus:bg-color-brand-yellow-200  hover:border-color-brand-yellow-200 focus:border-color-brand-yellow-200": !e.isDisabled && !e.isLoading,
      "bg-color-brand-yellow-100  border-color-brand-yellow-100 ": !e.isDisabled,
      "bg-color-brand-yellow-50 hover:bg-color-brand-yellow-50 border-color-brand-yellow-50 text-color-neutral-grey-40": e.isDisabled,
      "h-52 min-w-52": !e.isSmall,
      "h-38 min-w-38": e.isSmall,
      relative: e.isLoading
    }],
    "data-component": e.$options.name,
    disabled: e.isDisabled || e.isLoading,
    type: e.getType,
    rel: e.getRel,
    target: e.getTarget,
    href: e.getHref,
    "aria-label": e.ariaLabel
  }, e.tracking), {
    default: p(() => [
      e.isLoading ? (o(), a("span", u, [
        f(n)
      ])) : l("", !0),
      e.hasIconSlot() ? (o(), a("span", {
        key: 1,
        class: r(["w-24 h-24 shrink-0", {
          invisible: e.isLoading
        }]),
        "data-test-id": "icon"
      }, [
        s(e.$slots, "icon")
      ], 2)) : l("", !0),
      e.hasDefaultSlot() ? (o(), a("span", {
        key: 2,
        class: r(["font-bold text-text-l", {
          "ml-8": e.hasIconSlot(),
          invisible: e.isLoading
        }]),
        "data-test-id": "label"
      }, [
        s(e.$slots, "default")
      ], 2)) : l("", !0)
    ]),
    _: 3
  }, 16, ["class", "data-component", "disabled", "type", "rel", "target", "href", "aria-label"]);
}
const L = /* @__PURE__ */ g(i, [["render", h]]);
export {
  L as default
};
